<template>
  <div id="notifications-dropdown" ref="notifications-dropdown" class="notifications__dropdown p-2 text-left">
    <!-- Notifications Header -->
    <h5 class="heading heading--sm mb-2">
      {{ $t('text.notifications') }}
      <span v-if="count > 0" v-html="countText"></span>
    </h5>

    <!-- Notifications List -->
    <div v-if="sorted.length">
      <div class="b2b-scroll-list-container mb-1">
        <ul class="b2b-scroll-list">
          <notification-item
            v-for="notification in sorted"
            :key="notification.id"
            :notification="notification"
            @update:notification-read="updateNotification"
          ></notification-item>
        </ul>
      </div>
      <div class="buttons">
        <pdl-link button secondary block :href="`${encodedContextPath}/notifications/`">
          {{ $t('product.family.view.all.hero') }}
        </pdl-link>
        <pdl-link button secondary block :href="`${encodedContextPath}/notification-settings/`">
          {{ $t('notifications.B2B.settings.goTo') }}
        </pdl-link>
        <pdl-button tertiary block @click="markAllRead">
          {{ $t('notifications.B2B.markAsRead') }}
        </pdl-button>
      </div>
    </div>

    <div v-else>
      <div class="b2b-scroll-list-container mb-1">
        <div class="py-4 m-2">
          {{ $t('notifications.B2B.allCaughtUp') }}
        </div>
      </div>
      <div class="buttons">
        <pdl-link button secondary block :href="`${encodedContextPath}/notification-settings/`">
          {{ $t('notifications.B2B.settings.goTo') }}
        </pdl-link>
      </div>
    </div>
  </div>
</template>
<script>
import sortBy from 'lodash/sortBy';
import {mapActions, mapState} from 'vuex';
import {PdlButton} from '@pedal/pdl-button';
import {PdlLink} from '@pedal/pdl-link';
import NotificationItem from '@/components/containers/notifications/NotificationItem.vue';

export default {
  name: 'NotificationsDropdown',
  components: {
    PdlLink,
    PdlButton,
    NotificationItem,
  },

  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    textNew: {
      type: String,
      default: 'new',
    },
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
    count() {
      return this.notifications !== null
        ? this.notifications.filter((notification) => !notification.readStatus).length
        : '0';
    },

    countText() {
      return ` (${this.count} ${this.textNew})`;
    },

    sorted() {
      return sortBy(this.notifications, (e) => new Date(e.dateReceived)).slice(0, 20);
    },
  },

  methods: {
    markAllRead() {
      return this.notifications.forEach((notification) => this.updateNotificationRead(notification.id));
    },

    markRead(notification) {
      notification.readStatus = true;
      return notification;
    },

    updateNotification(id) {
      // axios.put()
      this.updateNotificationRead(id);
    },

    ...mapActions('notifications', ['updateNotificationRead']),
  },
};
</script>
